function Tips() {
    return (
        <>
            Travel tips go here
        </>
    );
}
  
export default Tips;